<template>
  <div></div>
</template>
<script>
import { mapActions, mapMutations } from "vuex";

export default {
  data() {
    return {
      resPonse: {},
    };
  },
  methods: {
    ...mapActions({
      tokenOneId: "auth/tokenOneId",
    }),
    async setProfile() {
      let { state, code } = this.$route.query;
      if (state && code) {
        try {
          await this.tokenOneId({
            code,
            state,
          });
        } catch (e) {
       
        }
      }
    },
  },
  created() {
    this.setProfile();
  },
};
</script>
